// project settings, you can change only PROJECT_NAME, BASE_URL and WEBSITE_URL otherwise it can break the app
export const PROJECT_NAME = 'Segdel marketplace';
export const BASE_URL = 'https://api.segdel.ca';
export const WEBSITE_URL = 'https://segdel.ca';
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin = BASE_URL + '/api/v1/dashboard/admin/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL = '';
export const export_url = BASE_URL + '/storage/';
export const example = BASE_URL + '/';

// map api key, ypu can get it from https://console.cloud.google.com/apis/library
export const MAP_API_KEY = 'AIzaSyBpNC0PG5fT4X6W2_ZqWi1lGBebJ2K2Ufo';

// firebase keys, do not forget to change to your own keys here and in file public/firebase-messaging-sw.js
export const VAPID_KEY =
  'BMll8oY-iuu_EDdtdv8V-T00qlbjXaD6DBLSTrfesbTx61zTFJTgJJwq3g8uD0TwUvJLI7oXAWCNu_Yw70iUfpA';
export const API_KEY = 'AIzaSyDOIHePU_rX3YavYumWNBj3bJD1-VrGuZI';
export const AUTH_DOMAIN = 'segdel-f746a.firebaseapp.com';
export const PROJECT_ID = 'segdel-f746a';
export const STORAGE_BUCKET = 'gs://segdel-f746a.firebasestorage.app';
export const MESSAGING_SENDER_ID = '166256586578';
export const APP_ID = '1:166256586578:web:820fd4a73c7822e06cd48b';
export const MEASUREMENT_ID = 'G-X70KM4YDH7';

// recaptcha key, you can get it from https://www.google.com/recaptcha/admin/create
export const RECAPTCHASITEKEY = '6LdW0WErAAAAAJC4N8o4sJhETpIFRWmiFpLeCS1r';

// demo data, no need to change
export const LAT = 47.4143302506288;
export const LNG = 8.532059477976883;
export const DEMO_SELLER = 334; // seller_id
export const DEMO_SELLER_UUID = '3566bdf6-3a09-4488-8269-70a19f871bd0'; // seller_id
export const DEMO_SHOP = 599; // seller_id
export const DEMO_DELIVERYMAN = 375; // deliveryman_id
export const DEMO_MANEGER = 114; // deliveryman_id
export const DEMO_MODERATOR = 297; // deliveryman_id
export const DEMO_ADMIN = 107; // deliveryman_id
export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/svg',
];
